import { Typography } from "@mui/material"
import styles from "./typography.module.css"

export const TextHeader = ({ text, onClick, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textHeader}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}
export const TextPrimaryLight = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textPrimaryLight}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}

export const TextPrimary = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textPrimary}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}
export const TextPrimaryBold = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textPrimaryBold}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}
export const TextMid = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textMid}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}
export const TextMidMedium = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textMidMedium}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}
export const TextMidBold = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textMidBold}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}

export const TextBig = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textBig}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}
export const TextBigBold = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textBigBold}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}

export const TextHuge = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textHuge}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}
export const TextHugeBold = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textHugeBold}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}


export const TextSmall = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textSmall}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}

export const TextSmallBold = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textSmallBold}
            style={{ color: color }}
        >
            {text}
        </Typography>
    )
}

export const TextSmaller = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textSmaller}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}

export const TextSmallerBold = ({ text, onClick = null, color }: { text: string, onClick?: any, color?: any }) => {

    return (
        <Typography
            onClick={() => {
                if (onClick) {
                    onClick();
                }
            }}
            className={styles.textSmallerBold}
            sx={{ color: color }}
        >
            {text}
        </Typography>
    )
}